import { useKeycloak } from "@react-keycloak/web";
import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import avatar from "../../../images/avatar/1.jpg";
import { useTranslation } from "react-i18next";
import request from "../../services/request";
import { ThemeContext } from "../../../context/ThemeContext";
import Spinner from 'react-bootstrap/Spinner';

const Header = ({ onNote, toggle, onProfile, onNotification, onBox }) => {
  const lngs = {
    en: { nativeName: "English" },
    tr: { nativeName: "Türkçe" },
  };

  const { routes, spinner, changeSpinnerStatus, changeNotificationTabStatus, notificationCount, refreshNotificationHandle } = useContext(ThemeContext);
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const [username, setUsername] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);
  const [selectedLang, setSelectedLang] = useState(lngs.tr.nativeName);
  const { keycloak } = useKeycloak();

  const logOut = () => {
    //keycloak?.logout({redirectUri: window.location.origin});
    const token = localStorage.getItem("id_token");
    const url = keycloak.createLogoutUrl();
    localStorage.removeItem("token");
    localStorage.removeItem("id_token");
    window.location.href = url.replace("redirect_uri", "post_logout_redirect_uri") + `&id_token_hint=${token}`;
  };

  const gotoProfile = () => {
    keycloak?.accountManagement();
  };

  const onChangeLang = (lang, langScreenText) => {
    setSelectedLang(langScreenText);
    i18n.changeLanguage(lang);
    // localStorage.setItem("selectedLanguage", lang);
    // request({
    //   url: "lang/change-lang",
    //   method: "POST",
    //   data: {
    //     body: {
    //       lang: lang,
    //     },
    //   },
    // }).then((response) => {
    //   if (response.responseStatus === "SUCCESS") {
    //   }
    // });
  };

  useEffect(() => {
    setUsername(keycloak.idTokenParsed.given_name+ " " + keycloak.idTokenParsed.family_name);
    if (i18n.languages.length > 1) {
      onChangeLang(i18n.languages[1],lngs[i18n.languages[1]].nativeName) 
    }else {
      onChangeLang(i18n.languages[0],lngs[i18n.languages[0]].nativeName) 
    }
  }, []);

  useEffect(() => {
    let path = location.pathname.split("/");
    let findedRoute = routes.find((r) => {
      let tempUrl = r.url.split("/");
      if (tempUrl[tempUrl.length - 1] == path[path.length - 1]) {
        return r;
      }
    });
    setPageTitle(findedRoute?.title);
    refreshNotificationHandle(true);
  }, [location]);  

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                lang="tr"
                style={{ textTransform: "capitalize" }}
              >
                {pageTitle != "" ? pageTitle : "Anasayfa"}
              </div>
            </div>

            <ul className="navbar-nav header-right">
              {/* loader */}
              {spinner && <Spinner className={"service-loader"} animation="border" />}
              {/* <button className="btn btn-primary" onClick={()=> {changeSpinnerStatus(false)}}>Click me</button> */}
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  as={Link}
                  variant=""
                  className="nav-link i-false"
                  to="#"
                  role="button"
                  data-toggle="dropdown"
                >
                  <div className="header-info">
                    <span className="text-dark text-capitalize">
                      {selectedLang}
                    </span>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  alignRight
                  className="dropdown-menu dropdown-menu-right"
                >
                  {Object.keys(lngs).map((lng) => (
                    <Link
                      to="#"
                      key={lng}
                      className="dropdown-item ai-icon"
                      onClick={() => onChangeLang(lng, lngs[lng].nativeName)}
                    >
                      <span className="ml-2">{lngs[lng].nativeName}</span>
                    </Link>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              { <li className="nav-item dropdown notification_dropdown">
                <Dropdown className="no-carat transparrent">
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-basic"
                    className="nav-link  ai-icon i-false"
                    style={{ backgroundColor: "static" }}
                  >
                    <Link onClick={() => changeNotificationTabStatus(true)} to={'/'} className="">
                      <i
                        className="flaticon-381-ring"
                        style={{ color: "gray" }}
                      ></i>
                      {notificationCount > 0 && <div><span style={{ color: 'white', fontSize: '12px', right: '3px', top: '3px', position: 'absolute', backgroundColor: '#DE350B', padding: '4px 8px', borderRadius: '50%', fontWeight: 'normal'}}>{notificationCount}</span></div>}
                    </Link>
                  </Dropdown.Toggle>
                </Dropdown>
              </li>}

              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  as={Link}
                  variant=""
                  className="nav-link i-false"
                  to="#"
                  role="button"
                  data-toggle="dropdown"
                >
                  <div className="header-info">
                    <span className="text-dark text-capitalize">
                      {username || t("header.bulunamadi")}
                    </span>
                    {/* <small>ADMIN</small> */}
                  </div>
                  {/* <img src={profile2} width={20} alt="" /> */}
                </Dropdown.Toggle>
                <Dropdown.Menu
                  alignRight
                  className="dropdown-menu dropdown-menu-right"
                >
                  <Link className="dropdown-item ai-icon" onClick={gotoProfile} to="#">
                    <svg
                      id="icon-user1"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-primary"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                      <circle cx={12} cy={7} r={4} />
                    </svg>
                    <span className="ml-2">{t("header.profile")} </span>
                  </Link>
                  <Link className="dropdown-item ai-icon" onClick={logOut} to="#">
                    <svg
                      id="icon-logout"
                      xmlns="http://www.w3.org/2000/svg"
                      className="text-danger"
                      width={18}
                      height={18}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16 17 21 12 16 7" />
                      <line x1={21} y1={12} x2={9} y2={12} />
                    </svg>
                    <span className="ml-2">{t("header.logout")} </span>
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
